import { mapState } from 'vuex';

export default {
    name: 'wai_diseases',
    props: {
        diseases : Array
    },

    components: {
                 
    },    

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
        l : function(state){
            return this.$root.platform.language.get()
        }
    }),

    methods : {

        cuiName : function(obj){

            console.log("OBJ", obj, obj.CUIName, obj.Name)

            return this.$root.f.flball(
                /*this.$f.deep(this.$store, 'state.cache.CUINAME' + this.l +'.' + obj.CUI + ".str") ||*/ obj.CUIName || obj.Name
            )
        },
       
    },
}